import { strategyToOptions } from "@/common/utils/strategyToOptions";

export const getNotificationProviderOptionFromPossibleProviders = (possibleProviders: Record<string, string>) => {
  return Object.entries(possibleProviders).reduce(((prev, [label, value]) => ({ ...prev, [value]: label })), {});
}

export const getNotificationProvidersOptionsFromPossibleProviders = (possibleProviders: Record<string, string>) => {
  return strategyToOptions({
    all: 'Todos',
    ...getNotificationProviderOptionFromPossibleProviders(possibleProviders),
  });
}
